import camelize from 'camelize';
import urlJoin from 'url-join';


export const APP_DATA_REQUEST = 'APP_DATA_REQUEST';
export const APP_DATA_SUCCESS = 'APP_DATA_SUCCESS';
export const APP_DATA_FAILURE = 'APP_DATA_FAILURE';
export const APP_CONFIG_REQUEST = 'APP_CONFIG_REQUEST';
export const APP_CONFIG_SUCCESS = 'APP_CONFIG_SUCCESS';
export const APP_CONFIG_FAILURE = 'APP_CONFIG_FAILURE';

const getAppConfigRequest = () => ({
  type: APP_CONFIG_REQUEST,
});

const getAppConfigSuccess = (payload) => ({
  type: APP_CONFIG_SUCCESS,
  payload,
});

const getAppConfigFailure = (error) => ({
  type: APP_CONFIG_FAILURE,
  error,
});

const getAppDataRequest = () => ({
  type: APP_DATA_REQUEST,
});

const getAppDataSuccess = (payload) => ({
  type: APP_DATA_SUCCESS,
  payload,
});

const getAppDataFailure = (error) => ({
  type: APP_DATA_FAILURE,
  error,
});

const normalizeAppData = (data) => {
  const { sections, ...rest } = data;

  const bySlug = sections.reduce((result, item) => {
    result[item.slug] = item;
    return result;
  }, {});
  const navItems = sections.map(({ slug }) => slug);

  return {
    project: { ...rest },
    sections: {
      bySlug,
      navItems,
    },
  };
};

const defaultAppConfigUrl = urlJoin(window.BASE_PATH || '/', 'config.json');

export const getAppConfig = (url = defaultAppConfigUrl) => (dispatch, getState) => {
  dispatch(getAppConfigRequest());

  fetch(url, { credentials: 'include' })
    .then(response => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response;
    })
    .then(response => response.json())
    .then(data => camelize(data))
    .then(data => dispatch(getAppConfigSuccess(data)))
    .catch(err => {
      dispatch(getAppConfigFailure(err));
      console.error(err);
    });
};

const defaultAppDataUrl = urlJoin(window.BASE_PATH || '/', 'data', 'main.json');

export const getAppData = (url = defaultAppDataUrl) => (dispatch, getState) => {
  dispatch(getAppDataRequest());

  fetch(url, { credentials: 'include' })
    .then(response => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response;
    })
    .then(response => response.json())
    .then(data => camelize(data))
    .then(data => normalizeAppData(data))
    .then(data => dispatch(getAppDataSuccess(data)))
    .catch(err => {
      dispatch(getAppDataFailure(err));
      console.log(err);
    });
};



// WEBPACK FOOTER //
// ./src/actions/appActions.js